// Whtazao.js
import React from 'react';

const WhatsApp = ({classe}) => {

    return (
        <div class={classe}>
            <a
                href="https://wa.me/5547991839432"
                class="whatsapp-link-icone"
                target="_blank"
                rel="noopener noreferrer"
            >
                <i class="fab fa-whatsapp"></i>
            </a>
            <span class="whatsapp-texto-flutuante">Precisa de ajuda?</span>
        </div>
    );
};

export default WhatsApp;